import { publicRequest } from '../../requestMeth';
import { validatePlan } from './model';
import { readBackground } from './files';
export function createPlanApi(token) {
  const request = async (method, url, data, options = {}) => {
    try { return (await publicRequest.request({ method, url: `plant-plans${url}`, data, ...options, headers: { Authorization: `Bearer ${token}` } })).data; }
    catch (error) {
      const failure = new Error(error.response?.data?.message || 'No se pudo completar la operación. Revisá la conexión y reintentá.');
      failure.status = error.response?.status; throw failure;
    }
  };
  return {
    async scope() {
      const scope = await request('get', '/scope');
      if (scope.canConfigure) {
        // Reutiliza los catálogos existentes; el alcance del módulo sigue siendo autoritativo.
        try {
          const headers = { Authorization: `Bearer ${token}` };
          const [companies, branches] = await Promise.all([
            publicRequest.get('master/companies?type=company', { headers }),
            publicRequest.get('master/companies?type=branch_offices', { headers }),
          ]);
          const companyNames = new Map(companies.data.map(c => [c.id, c.name]));
          const branchNames = new Map(branches.data.map(b => [b.id, b.name]));
          scope.companies = scope.companies.map(c => ({ ...c, name: companyNames.get(c.id) || c.name }));
          scope.branches = scope.branches.map(b => ({ ...b, name: branchNames.get(b.id) || b.name }));
        } catch { throw new Error('No se pudieron cargar las empresas y sucursales. Reintentá las opciones.'); }
      }
      return scope;
    },
    list: branchId => request('get', `?branchId=${branchId}`),
    devices: branchId => request('get', `/devices?branchId=${branchId}`),
    object: (id, key) => request('get', `/${id}/objects/${encodeURIComponent(key)}`),
    async get(id) {
      const plan = await request('get', `/${id}`);
      if (plan.background) {
        const blob = await request('get', `/${id}/background?revision=${plan.revision}`, undefined, { responseType: 'blob' });
        const ext = { 'image/png': 'png', 'image/jpeg': 'jpg', 'image/webp': 'webp' }[blob.type];
        plan.background = await readBackground(new File([blob], `background.${ext}`, { type: blob.type }));
      }
      return plan;
    },
    async save(draft, saved, branchId) {
      const clean = validatePlan(draft);
      const unchanged = !!saved?.background && clean.background?.dataUrl === saved.background.dataUrl;
      const payload = { ...clean, background: undefined, branchId, revision: draft.revision, backgroundAction: !clean.background ? 'remove' : unchanged ? 'keep' : 'replace' };
      const form = new FormData(); form.append('payload', JSON.stringify(payload));
      if (payload.backgroundAction === 'replace') {
        const [header, base64] = clean.background.dataUrl.split(',');
        const mime = header.slice(5).split(';')[0];
        const ext = { 'image/png': 'png', 'image/jpeg': 'jpg', 'image/webp': 'webp' }[mime];
        const bytes = Uint8Array.from(atob(base64), c => c.charCodeAt(0));
        form.append('background', new Blob([bytes], { type: mime }), `background.${ext}`);
      }
      const result = await request(draft.id ? 'put' : 'post', draft.id ? `/${draft.id}` : '', form);
      return { ...result, background: clean.background };
    },
    remove: plan => request('delete', `/${plan.id}`, { revision: plan.revision }),
  };
}
